import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { codModoPresPropio, codModoPresTraslado, dscModoPresTraslado, dscModoPresPropio } from 'src/app/general/variables';
import { Denunciante } from 'src/app/models/Denunciante';
import { Persona } from 'src/app/models/Persona';
import { PersonaNaturalComponent } from '../PersonaNatural/persona-natural.component';
// import { DenunciaContenedorComponent } from '../../denuncia/denuncia-contenedor/denuncia-contenedor.component';
// import { Fur } from 'src/app/models/Fur';

@Component({
  selector: 'app-denunciante-congresista',
  templateUrl: './denunciante-congresista.component.html',
  styleUrls: ['./denunciante-congresista.component.css']
})
export class DenuncianteCongresistaComponent implements OnInit {

  denunciante: Denunciante = new Denunciante();

  codModoPresPropio = codModoPresPropio;
  codModoPresTraslado = codModoPresTraslado;
  dscModoPresPropio = dscModoPresPropio;
  dscModoPresTraslado = dscModoPresTraslado;
  flgLectura = false;

  flgPropio = false;

  @Output()  denunCongresistaOut = new EventEmitter();
  @Output() cambioTipoDocOut = new EventEmitter();


  @ViewChild('pn1') personaNaturalC1: PersonaNaturalComponent;
  @ViewChild('pn2') personaNaturalC2: PersonaNaturalComponent;
  @ViewChild('pn3') personaNaturalC3: PersonaNaturalComponent;

  constructor() {

    this._setCodModoPresent(codModoPresPropio);

  }

  _setCodModoPresent(codModo: string) {

    this.denunciante.cdenuncianteCodmodopresent = codModo;

    this.flgPropio = (codModo == codModoPresPropio);

  }

  _cambioTipoDocOut() {

    this.cambioTipoDocOut.emit();

  }

  ngOnInit() {
  }

  _cambioModo(codModo: string) {

    console.log('=======0codModo');
    console.log(codModo);

    this._setCodModoPresent(codModo);



    if (this.flgPropio) {

      setTimeout(() => {

        this.personaNaturalC1.setTipDocumentPn(1);

      }, 50);



    } else {

      setTimeout(() => {

        this.personaNaturalC2.setTipDocumentPn(1);

        // console.log("=======this.personaNaturalC2.dscMask",this.personaNaturalC2.dscMask);

      }, 500);

      setTimeout(() => {

        this.personaNaturalC3.setTipDocumentPn(1);

        // console.log("=======this.personaNaturalC3.dscMask",this.personaNaturalC3.dscMask);

      }, 500);

    }



  }

  setModoLectura(flgValor: boolean) {

    this.flgLectura = flgValor;

    if (this.flgPropio) {

      if (flgValor) {this.personaNaturalC1.personaNaturalCReadEnable(); } else {this.personaNaturalC1.personaNaturalCReadDisable(); }



    } else {

      if (flgValor) {this.personaNaturalC2.personaNaturalCReadEnable(); } else {this.personaNaturalC2.personaNaturalCReadDisable(); }

      if (flgValor) {this.personaNaturalC3.personaNaturalCReadEnable(); } else {this.personaNaturalC3.personaNaturalCReadDisable(); }

    }

  }

  _datosComplementOut(persona: Persona) {

    this.denunCongresistaOut.emit(persona);

  }

  getDenunCongresista() {

    let vPersona: Persona = null;
    let vPersonaCompl: Persona = null;

    if (this.flgPropio) {

      vPersona = this.personaNaturalC1.persona;

    } else {

      vPersona = this.personaNaturalC2.persona;
      vPersonaCompl = this.personaNaturalC3.persona;

    }

    this.denunciante.persona = vPersona;
    this.denunciante.personaComplemento = vPersonaCompl;

    return this.denunciante;


  }

  setDenunCongresista(denunciante: Denunciante) {

    this._setCodModoPresent(denunciante.cdenuncianteCodmodopresent);

    setTimeout(() => {

      if (this.flgPropio) {

        this.personaNaturalC1.setPersonaNaturalC(denunciante, 1);

      } else {

        this.personaNaturalC2.setPersonaNaturalC(denunciante, 1);
        this.personaNaturalC3.setPersonaNaturalC(denunciante, 2);

      }

    }, 50);

  }

  getDcPersComponent() {

    // if(this.flgPropio)
    // {

    //   vPersona = .persona;

    // }else{

    //   vPersona = this.personaNaturalC2.persona;
    //   vPersonaCompl = this.personaNaturalC3.persona;

    // }

    // this.denunciante.persona = vPersona;
    // this.denunciante.personaComplemento = vPersonaCompl;

    return (this.flgPropio ? this.personaNaturalC1 : this.personaNaturalC2);


  }

  // getDcPersComplComponent()
  // {

  //   // if(this.flgPropio)
  //   // {

  //   //   vPersona = .persona;

  //   // }else{

  //   //   vPersona = this.personaNaturalC2.persona;
  //   //   vPersonaCompl = this.personaNaturalC3.persona;

  //   // }

  //   // this.denunciante.persona = vPersona;
  //   // this.denunciante.personaComplemento = vPersonaCompl;

  //   return (!this.flgPropio ? this.personaNaturalC3 : null);


  // }

}
